
import React from 'react';

import {requiredMark} from './required-mark.module.styl';

type Props = {
    label?: React.ReactNode,
};
export const RequiredMark = ({label}: Props) => (
    <>{label}<span className={requiredMark}>*</span></>
);
